/* Trail Can Series No. 1 — Lambda Coffee */
(function () {
  'use strict';

  /* ── Staggered fade-in ─────────────────────────────────── */
  function initFade() {
    var els = document.querySelectorAll('.tc-fade');
    els.forEach(function (el, i) {
      setTimeout(function () { el.classList.add('in'); }, 80 + i * 110);
    });
  }

  /* ── Countdown ─────────────────────────────────────────── */
  function initCountdown() {
    var container = document.getElementById('tc-countdown');
    if (!container) return;

    var target = new Date(container.getAttribute('data-launch')).getTime();
    if (isNaN(target)) return;

    var units = {
      days:  document.getElementById('tc-cd-d'),
      hours: document.getElementById('tc-cd-h'),
      mins:  document.getElementById('tc-cd-m'),
      secs:  document.getElementById('tc-cd-s')
    };
    var launched = document.getElementById('tc-launched');

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        container.style.display = 'none';
        if (launched) launched.style.display = 'block';
        return;
      }
      units.days.textContent  = pad(Math.floor(diff / 86400000));
      units.hours.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      units.mins.textContent  = pad(Math.floor((diff % 3600000) / 60000));
      units.secs.textContent  = pad(Math.floor((diff % 60000) / 1000));
      setTimeout(tick, 1000);
    }
    tick();
  }

  /* ── Hex-Grid Spotlight (Canvas / destination-out) ─────── */
  function initSpotlights() {
    var canvas = document.getElementById('tc-canvas');
    if (!canvas || !canvas.getContext) return;

    var ctx  = canvas.getContext('2d');
    var page = document.getElementById('tc-page');

    var hexes   = [];
    var HEX_R   = 12;   // recalculated on resize
    var GAP     = 0.8;  // tiny gap — just a hairline
    var SPOT_R  = 200;  // spotlight radius in px

    // Lissajous motion — same organic drift as before
    var spot = { bx: 0.45, by: 0.45, ax: 0.32, ay: 0.26, fx: 0.48, fy: 0.37 };

    function drawHex(cx, cy, r) {
      ctx.beginPath();
      for (var i = 0; i < 6; i++) {
        var angle = (Math.PI / 3) * i;
        var x = cx + r * Math.cos(angle);
        var y = cy + r * Math.sin(angle);
        if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
      }
      ctx.closePath();
    }

    function buildGrid(w, h) {
      hexes = [];
      var colW = HEX_R * 1.5;
      var rowH = HEX_R * Math.sqrt(3);
      var cols = Math.ceil(w / colW) + 2;
      var rows = Math.ceil(h / rowH) + 2;
      for (var col = -1; col < cols; col++) {
        for (var row = -1; row < rows; row++) {
          hexes.push({
            cx:    col * colW,
            cy:    row * rowH + (col % 2 !== 0 ? rowH / 2 : 0),
            alpha: 0   // current transparency — lerped toward target each frame
          });
        }
      }
    }

    function resize() {
      HEX_R = window.innerWidth < 600 ? 8 : 12;
      canvas.width  = page.offsetWidth;
      canvas.height = page.offsetHeight;
      buildGrid(canvas.width, canvas.height);
    }
    resize();
    window.addEventListener('resize', resize);

    // Lissajous spotlight motion
    var spot = { bx: 0.45, by: 0.45, ax: 0.32, ay: 0.26, fx: 0.48, fy: 0.37 };
    var SPOT_R = 160;

    var LERP_IN  = 0.018;
    var LERP_OUT = 0.04;
    var t = 0;

    function draw() {
      t += 0.006;
      var w = canvas.width;
      var h = canvas.height;

      var sx = (spot.bx + spot.ax * Math.sin(t * spot.fx)) * w;
      var sy = (spot.by + spot.ay * Math.cos(t * spot.fy)) * h;
      // Wobbling blob — distort radius with overlapping sine harmonics
      var BLOB_R   = SPOT_R;          // base radius
      var BLOB_MAX = SPOT_R + 55;     // outer bounding radius (base + max wobble)

      ctx.clearRect(0, 0, w, h);

      // 1. Full JET overlay
      ctx.globalCompositeOperation = 'source-over';
      ctx.fillStyle = 'rgba(58, 57, 62, 1)';
      ctx.fillRect(0, 0, w, h);

      // 2. Each hex lerps in/out based on whether it falls inside the blob
      ctx.globalCompositeOperation = 'destination-out';

      for (var i = 0; i < hexes.length; i++) {
        var hx = hexes[i];
        var dx = hx.cx - sx;
        var dy = hx.cy - sy;

        // Bounding-box fast skip
        if (dx > BLOB_MAX || dx < -BLOB_MAX || dy > BLOB_MAX || dy < -BLOB_MAX) {
          if (hx.alpha < 0.005) continue;
        }

        // Wobbled radius at this angle
        var angle  = Math.atan2(dy, dx);
        var wobble = 22 * Math.sin(2 * angle + t * 0.70)
                   + 16 * Math.sin(3 * angle - t * 0.50 + 1.2)
                   + 10 * Math.cos(5 * angle + t * 0.35 + 2.1)
                   +  7 * Math.sin(7 * angle - t * 0.20 + 0.8);
        var dist   = Math.sqrt(dx * dx + dy * dy);
        var inside = dist < (BLOB_R + wobble);

        var target = inside ? 1.0 : 0.0;
        var lerp   = (target > hx.alpha) ? LERP_IN : LERP_OUT;
        hx.alpha  += (target - hx.alpha) * lerp;

        if (hx.alpha < 0.005) continue;

        ctx.fillStyle = 'rgba(0,0,0,' + hx.alpha.toFixed(3) + ')';
        drawHex(hx.cx, hx.cy, HEX_R - GAP);
        ctx.fill();
      }

      // 3. Reset
      ctx.globalCompositeOperation = 'source-over';

      requestAnimationFrame(draw);
    }

    draw();
  }

  /* ── Init ──────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  function run() {
    initFade();
    initCountdown();
    initSpotlights();
  }
})();
